import React from "react";
import PropTypes from "prop-types";

export default function ClientActivations(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill={props.fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="send_24px">
        <path
          id="send_24px"
          d="M4.29513 20.8849L20.438 13.4049C21.1873 13.0549 21.1873 11.9149 20.438 11.5649L4.29513 4.08488C3.68457 3.79488 3.00925 4.28488 3.00925 4.99488L3 9.60488C3 10.1049 3.34228 10.5349 3.80483 10.5949L16.8764 12.4849L3.80483 14.3649C3.34228 14.4349 3 14.8649 3 15.3649L3.00925 19.9749C3.00925 20.6849 3.68457 21.1749 4.29513 20.8849Z"
        />
      </g>
    </svg>
  );
}

ClientActivations.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
ClientActivations.defaultProps = {
  className: "",
  fill: "#93ABCA",
  width: 15,
  height: 17
};
